import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";
import Search from "./Search";
import { Separator } from "./ui/separator";
import { SidebarTrigger } from "./ui/sidebar";
import UserProfileDropdown from "./UserProfileDropdown";

interface AppHeaderProps {
  onSearch?: (query: string) => void;
  notificationCount?: number;
  userName?: string;
  userEmail?: string;
  profilePhotoUrl?: string | null;
  className?: string;
}

const AppHeader = ({
  onSearch,
  notificationCount = 0,
  userName,
  userEmail,
  profilePhotoUrl,
  className,
}: AppHeaderProps) => {
  const navigate = useNavigate();

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  return (
    <header
      className={cn(
        "flex h-20 shrink-0 items-center gap-4 border-b border-indigo-50/50 bg-white/80 backdrop-blur-xl sticky top-0 z-50 px-4 md:px-8",
        className
      )}
    >
      {/* Sidebar Trigger */}
      <div className="flex items-center">
        <SidebarTrigger className="-ml-1 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg p-2 transition-colors" />
      </div>

      <Separator orientation="vertical" className="h-6 bg-slate-200/50" />

      {/* Search - takes available space */}
      <div className="flex-1 max-w-lg">
        <Search
          placeholder="Search internships, companies, resources..."
          onValueChange={(query) => {
            if (onSearch) {
              onSearch(query);
            } 
          }}
          className={{
            inputGroupClass: "w-full shadow-sm shadow-slate-100",
          }}
        />
      </div>

      {/* Right section - Notifications & User Profile */}
      <div className="ml-auto flex items-center gap-4">
        <NotificationBell
          count={notificationCount}
          onClick={handleNotificationClick}
        />

        <Separator orientation="vertical" className="h-8 bg-slate-200/50" />

        <UserProfileDropdown userName={userName} userEmail={userEmail} profilePhotoUrl={profilePhotoUrl} />
      </div>
    </header>
  );
};

export default AppHeader;
